// ボタン類で共通の枠・色・押下時の反応 (タッチでは hover が出ないため active で押下を示す)
export const BUTTON_BASE_CLASSES =
  "rounded-2xl border transition-[color,background-color,border-color,transform] duration-150 ease-in-out";

export const getButtonStateClasses = (isSelected: boolean, isDisabled: boolean): string => {
  if (isDisabled) {
    return isSelected
      ? "bg-MiraiPrimary/30 text-white cursor-not-allowed"
      : "bg-gray-200 text-gray-400 border-Border opacity-50 cursor-not-allowed";
  }
  return isSelected
    ? "bg-MiraiPrimary text-white border-MiraiPrimary active:bg-[#9a0001] active:scale-[0.97] cursor-pointer"
    : "bg-Surface text-TextPrimary border-Border hover:bg-Background active:bg-Border active:scale-[0.97] cursor-pointer";
};
